import { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";

export interface Step2FieldsInterface {
  projectGoals: string;
  typeOfMLProblem: string;
  endUser: string;
  typeOfDataAndStorage: string;
  privacyAndCompliance: string;
  frameworksOrLibraries: string;
  computeRequirment: string;
  deploymentStrategy: string;
  performanceMonitor: string;
  usageCost: string;
}

export interface Step3FieldsInterface {
    users?: {
        email?: string;
        roles: string[];
    }[];
    addUserLater?: boolean;
}

export enum PodOnboardingStep2FieldEnum {
  projectGoals = "projectGoals",
  typeOfMLProblem = "typeOfMLProblem",
  endUser = "endUser",
  typeOfDataAndStorage = "typeOfDataAndStorage",
  privacyAndCompliance = "privacyAndCompliance",
  frameworksOrLibraries = "frameworksOrLibraries",
  computeRequirment = "computeRequirment",
  deploymentStrategy = "deploymentStrategy",
  performanceMonitor = "performanceMonitor",
  usageCost="usageCost"
}

export interface AddUserProps {
  removeUserHandler: (index: number | Array<number>) => () => void;
  index: number;
  register: UseFormRegister<{
    users?: {
      email?: string;
      roles: string[];
    }[];
    addUserLater?: boolean;
  }>;
  setValue: UseFormSetValue<{
    users?: {
      email?: string;
      roles: string[];
    }[];
    addUserLater?: boolean;
  }>;
  errors: FieldErrors<Step3FieldsInterface>;
  field: {
    email?: string;
    roles: string[];
  };
  isSubmitted?: boolean;
}
